// import registerServiceWorker from './registerServiceWorker'

import React from 'react'
import ReactDOM from 'react-dom'
import ReactRouter from 'react-router'
import { ReactRouterDom, Router, Route, HashRouter, Link } from 'react-router-dom'

import HomePage from './components/HomePage'

let store            = require('./Store').store,
    Provider         = require('react-redux').Provider

// COMPONENTS
class Main extends React.Component {
    // Main is responsible for routing and displaying the corresponding components ("pages")
    render(){
        console.log("inside Main Component")
        console.log("checking this:", this)
        return (

            <HomePage />
        )
    }
}






// // DOM
//
// // render App when routes change
// window.onhashchange = function(){
//   renderApp()
// }
//
// function renderApp(){
//   // if (location.hash == '') {location.hash = 'home'} // (optional)
//   ReactDOM.render((
//     <Provider store={store}>
//
//       <Main />
//     </Provider>
//     ),
//     document.getElementById('app')
//   )
// }
//
// // render App on load
// renderApp()
//
// if (module.hot) {
//   module.hot.accept(Main, () => { render(Main) })
// }


ReactDOM.render(
    <Main />,
    document.getElementById('app')
)

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js